import React, { useEffect, useState } from 'react'
import { HeaderReferral } from '../../../components/Header/HeaderReferral'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link } from 'react-router-dom'
import moment from 'moment'
import DataTable from 'react-data-table-component'

export const ViewReferral = () => {
  toast.configure()

  const [data, setData] = useState([])

  // fetching emailfrom localstorage
  const userEmail = localStorage.getItem('email')

  // fetching all referrals
  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'referral-statistics/fetchMyReferrals', {
        referralEmail: userEmail,
      })
      .then((res) => {
        setData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.serialNumber,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Employee Name',
      cell: (row) => row.referred_by,
    },
    {
      name: 'Candidate Name',
      cell: (row) => row.candidate_name,
    },
    {
      name: 'Designation',
      cell: (row) => row.designation,
    },
    {
      name: 'Total Experience',
      cell: (row) => row.relevant_it_experience,
    },
    {
      name: 'Applied date',
      cell: (row) => moment(row.applied_date).format('DD-MM-YYYY'),
    },
    {
      name: 'Application Status',
      selector: (row) => row.application_status,
      sortable: true,
    },
  ]
  return (
    <div className="container p-3">
      <HeaderReferral />
      <div className="container">
        <div className="">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/add-referral" className="link text-primary">
                  Home
                </Link>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                My Referrals
              </li>
            </ol>
          </nav>
        </div>
        <div className="mt-5 w-100">
          <DataTable
            columns={columns}
            data={data}
            pagination
            highlightOnHover
            fixedHeader
          />
        </div>
      </div>
    </div>
  )
}
